module.exports = __webpack_public_path__ + "img/gem.420432a9.svg";